// HeroSection.jsx
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { FaHandHoldingUsd, FaSmile, FaUsers } from "react-icons/fa";
import heroImg from "../assets/19.png";
import "../css/Together.css";

const Stat = ({ value, label, suffix, icon }) => {
  return (
    <motion.div
      className="landing-page-techvison-mz-stat-card"
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 200 }}
    >
      <div className="landing-page-techvison-mz-stat-icon">{icon}</div>
      <h2>
        <CountUp
          start={0}
          end={value}
          duration={2.5}
          suffix={suffix || ""}
          enableScrollSpy={true}
        />
      </h2>
      <p>{label}</p>
    </motion.div>
  );
};

const HeroSection = () => {
  return (
    <section className="landing-page-techvison-mz-hero-container">
      {/* Left image */}
      <motion.div
        className="landing-page-techvison-mz-hero-left"
        initial={{ opacity: 0, x: -80 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <img src={heroImg} alt="Loan Support" />
      </motion.div>

      {/* Right content */}
      <motion.div
        className="landing-page-techvison-mz-hero-right"
        initial={{ opacity: 0, x: 80 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <h1>
          Empowering{" "}
          <motion.span
            className="landing-page-techvison-mz-animated-word"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            borrowers & growth
          </motion.span>{" "}
          together
        </h1>
        <p>
          With a commitment to transparency, quick loan processing, and flexible repayment options, 
          we bridge the credit gap for individuals, entrepreneurs, and small businesses.
        </p>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="landing-page-techvison-mz-cta-btn"
        >
          Explore Loan Schemes
        </motion.button>

        {/* Dynamic Stats */}
        <div className="landing-page-techvison-mz-stats">
          <Stat
            value={99}
            suffix="%"
            label="Borrower Satisfaction"
            icon={<FaSmile />}
          />
          <Stat
            value={50}
            suffix="Cr+"
            label="Loans Disbursed"
            icon={<FaHandHoldingUsd />}
          />
          <Stat
            value={120}
            suffix="+"
            label="Weekly Approved Loans"
            icon={<FaUsers />}
          />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;